import React, { useCallback, useContext } from "react";
import styles from "./index.module.scss";

import { Button } from "antd";
import classNames from "classnames";
import ItemStatus from "./components/ItemStatus";
import FileIcon from "./components/FileIcon";
import { SourceItem } from "../../../../../../ResourcePool/service";
import { ChapterContext } from "../../../../../CourseChapters/Index/Components/StuViewModal/store";
import Spacer from "../../../../../../../components/PreviewSourceModal/components/Spacer";
import SourceInfo from "../../../../../../../components/CourseComponents/Resource/ListItem/Components/SourceInfo";

interface CoursewareItemProps {
    data: SourceItem;
    indent: number;
    style?: React.CSSProperties;
}

export default function CoursewareItem({ data, indent }: CoursewareItemProps) {
    const { onViewCourseware } = useContext(ChapterContext);

    const handleClick = useCallback(() => {
        onViewCourseware(data.id);
    }, [data.id, onViewCourseware]);

    return (
        <div
            role="button"
            className={styles.root}
            style={{ paddingLeft: 30 * indent }}>
            <div className={classNames(styles.icon)}>
                <FileIcon ext={data.sourceFileEntity?.fileType || ""} />
            </div>

            <div className={styles.main}>
                <h1 className={styles.title}>
                    {data.sourceFileEntity?.fileName}{" "}
                    <ItemStatus status={"todo"} />
                </h1>
                <SourceInfo source={data} />
            </div>

            <Spacer />

            <div className={styles.buttons}>
                <Button
                    type="link"
                    className={styles.button}
                    onClick={handleClick}>
                    前往学习
                </Button>
            </div>
        </div>
    );
}
